import { getRoutePathWithId } from '@/utils/router-utils';

export const adminRoutePaths: Record<string, string> = {
  ROOT: '',
  ADMIN: 'admin',
  EMAILS: 'emails',
  USER_ACCESS: 'user-access',
};

export const getAdminRoute = (path: string, id?: string): string => {
  const fullpath = `${adminRoutePaths.ROOT}/${adminRoutePaths.ADMIN}/${path}`;
  if (id) {
    return getRoutePathWithId(fullpath, id);
  }
  return `${adminRoutePaths.ROOT}/${adminRoutePaths.ADMIN}/${path}`;
};
